import { Loader2 } from 'lucide-react';

const WasteSkeleton = () => {
  return (
    <div className="flex min-h-[300px] items-center justify-center">
      <Loader2 className="h-7 w-7 animate-spin text-primary" />
    </div>
  );
};

export default WasteSkeleton;
